import asArray from 'utils/arrays/asArray.util';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';

const fromDtoToCommission = (dto) => ({
  id: dto?.id,
  percentage: fromAnyToNumber(dto?.percentage),
  objectId: dto?.object_id,
  objectType: dto?.object_type,
});

const fromDtoToCommissionedStylist = (dto) => ({
  stylistId: dto?.id,
  stylistName: fromAnyToString(dto?.name),
  transferPolicy: fromAnyToString(dto?.transfer_policy),
  commissions: asArray(dto?.commissions).map(fromDtoToCommission),
});

const fromEntryToCategory = ([categoryId, category]) => ({
  categoryId,
  categoryName: category?.name,
  stylists: asArray(category?.stylists).map(fromDtoToCommissionedStylist),
});

const fromDtoToCategoryCommissions = (dto) => fromObjectToEntries(dto?.object_data).map(fromEntryToCategory);
const fromDtoToAggregateCommissions = (dto) =>
  (dto?.object_data?.['1']?.stylists ?? []).map(fromDtoToCommissionedStylist);

const fromDtoToStylistsCommissions = (dto) => ({
  allProducts: fromDtoToAggregateCommissions(dto?.results?.all_products),
  noShow: fromDtoToAggregateCommissions(dto?.results?.no_show),
  vouchers: fromDtoToAggregateCommissions(dto?.results?.vouchers),
  category: fromDtoToCategoryCommissions(dto?.results?.category),
});

export default fromDtoToStylistsCommissions;
